import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceState = () => React.useContext(Context)
export const usePlace = () => usePlaceState()?.place

const QUERY = gql`
  query Place($id: ID) {
    place(id: $id, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      resume
    }
  }
`

const PlacesLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlacesLoader
